import script from "./bulk-delete-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./bulk-delete-modal.vue?vue&type=script&setup=true&lang=js"

import "./bulk-delete-modal.vue?vue&type=style&index=0&id=4db18b5e&scoped=true&lang=css"
import "./bulk-delete-modal.vue?vue&type=style&index=1&id=4db18b5e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4db18b5e"]])

export default __exports__